import axios from "axios";
import React, { useRef, useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import fundo from "../../../../styles/fundo.svg";
import Swal from "sweetalert2";
import './style.css';

const FormContainer = styled.form`
  width: auto;
  background-color: #f4f4f5;
  display: flex; 
  align-items: flex-start;
  flex-direction: column;
  border: 1px solid #ccc;
`;

const Div = styled.div`
  width:96%;
  background-color:#f4f4f5;
  display: flex; 
  padding: 10px 10px;
  align-items: flex-end;
  gap: 20px 5px;
  flex-direction: row;
 
`;


const TextAreaContainer = styled.div`
  width: auto;
  display: flex;
  flex-direction: column;
  
  textarea{
    width: 500px;
    height: 100px;
    background-color: #f4f4f5;
    border: 1px solid #ccc;
    border-radius: 10px;
    color: #3a3f42;
    padding: 5px;
  }


`;

const InputArea = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  select {
    width: 100%;
    height: 42px;
    padding: 0 0px;
    border: 1px solid #ccc;
    border-radius: 10px;
    background-color: #f4f4f5;
    color: #3a3f42;
  }

`;



const InputTitle = styled.input`
  width: 480px;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 0px 10px;
  background-color: #f4f4f5;
  color: #3a3f42;
`;

const Label = styled.label`
  color: #3a3f42;
  font-weight: bold;
  font-family: 'Open Sans', sans-serif;
  font-size: 18px;
  margin: 0px 5px;

  @media (max-width: 500px) {
    font-size: 16px;
  }
`;



const Button = styled.button`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 10px ;
  cursor: pointer;
  border: none;
  background-image: url(${fundo});
  color: #fff;
  font-size: bold;
  font-size: 20px;
  gap: 5px;
  margin-top: 10px;
  border: 1px solid #ccc;
  border-radius: 10px;


`;





const Form = ({ urlApi, modalNovoCard, novoCard, fetchCard, usuario, visualizador, quadro }) => {
  const ref = useRef();



  //Token da api
  const token = localStorage.getItem('token');
  const id = localStorage.getItem('id');


  const showPopUp = () => {
    return new Promise((resolve) => {
      Swal.fire({
        title: "Deseja confirmar?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        customClass: {
          container: 'custom-swal-container', // Estiliza o container principal
          title: 'custom-swal-title', // Estiliza o título
          confirmButton: 'custom-swal-confirm-button', // Estiliza o botão de confirmação
          cancelButton: 'custom-swal-cancel-button', // Estiliza o botão de cancelamento
          popup: 'custom-swal-popup', // Estiliza o popup
          icon: 'custom-swal-icon' // Estiliza o ícone
        },
      }).then((result) => {
        resolve(result.value);
      });
    });
  };



  //---------------------------------FUNCAO QUE CRIA NOVO CARTAO/ENVIA EMAIL-------------------------------------------//
  const [situacaoSelecionada, setSituacaoSelecionada] = useState("");

  const opcoesSituacao = {
    AF: "A Fazer",
    PR: "Programado",
    AN: "Em Andamento",
    VA: "Em Validação",
    PA: "Pausado",
    CO: "Concluído",
    CA: "Cancelado",
    AR: "Arquivado",
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const user = ref.current;

    const id_criador = id;
    const id_responsavel = user.id_responsavel.value;
    const titulo_cartao = user.titulo_card.value.trim();
    const descricao_cartao = user.descricao_card.value.trim();

    if (!titulo_cartao || !descricao_cartao || !id_responsavel || !situacaoSelecionada) {
      return toast.warn("Preencha todos os campos!");
    }

    const userConfirmed = await showPopUp();
    if (!userConfirmed) return;

    try {
      const requestData = {
        id_lista: novoCard.ID_LISTA,
        id_quadro: novoCard.ID_QUADRO,
        id_criador,
        id_responsavel,
        titulo_cartao,
        descricao_cartao,
        situacao: situacaoSelecionada,
      };

      await axios.post(`${urlApi}painel-monitoramento/add-cartao`, requestData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success("Cartão criado com sucesso.");
      fetchCard();
      setTimeout(() => modalNovoCard(), 1000);

      // === Dados dinâmicos para o e-mail ===
      const usuarioResponsavel = usuario.find(user => user.COD_FUNCIONARIO == id_responsavel);
      const usuarioCriador = usuario.find(user => user.COD_FUNCIONARIO == id_criador);
      const quadroSelecionado = quadro.find(q => q.ID_QUADRO === novoCard.ID_QUADRO);

      const emailRecebe = usuarioResponsavel?.EMAIL || '';
      const nomeRecebe = usuarioResponsavel?.NOME || '';
      const loginCriador = usuarioCriador?.NOME || '';
      const tituloQuadroFiltrado = quadroSelecionado?.TITULO_QUADRO || '';


      // === Envia o e-mail com os dados sincronizados (somente se criador ≠ responsável) ===
      if (id_criador != id_responsavel) {
        await axios.get(`${urlApi}painel-monitoramento/novo-cartao-responsavel`, {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            userTo: emailRecebe,
            criador: loginCriador,
            titulo: tituloQuadroFiltrado,
            nomeUsuario: nomeRecebe,
            titulo_cartao
          }
        });
      }



    } catch (error) {
      const errorMessage = error.response?.data?.error || "Erro ao criar cartão.";
      toast.error(errorMessage);
      console.error(error);
    }
  };




  //----------------------------------FILTRAR OS USUÀRIO--------------------------------------------------------------//
  //Mostra apenas os usuário com qual foi compartilhaodo o quadro
  const usuariosVisualizadores = visualizador
    .filter(v => v.ID_QUADRO === novoCard.ID_QUADRO) // Ou editarCartao.id_quadro, caso seja um quadro e não coluna
    .map(v => usuario.find(user => user.COD_FUNCIONARIO === v.COD_FUNCIONARIO)) // Mapeia para encontrar os usuários correspondentes
    .filter(Boolean); // Remove possíveis undefined caso algum id_usuario não seja encontrado


  return (
    <div >
      <FormContainer ref={ref} onSubmit={handleSubmit}>

        <Div>

          <InputArea>
            <Label>Responsável:</Label>
            <select
              name="id_responsavel"
              isSearchable

            >
              <option value="" >Escolha </option>
              {usuariosVisualizadores.map((user, index) => (
                <option key={index} value={user.COD_FUNCIONARIO}>
                  {user.LOGON} - {user.NOME}
                </option>
              ))}
            </select>
          </InputArea>


          <InputArea>
            <Label>Situação:</Label>
            <select
              name="situacao"
              value={situacaoSelecionada}
              onChange={(e) => setSituacaoSelecionada(e.target.value)}
            >
              <option value="" disabled>Escolha...</option>
              {Object.entries(opcoesSituacao).map(([valor, label]) => (
                <option key={valor} value={valor}>{label}</option>
              ))}
            </select>
          </InputArea>
        </Div>
        <Div>
          <InputArea>
            <Label>Título:</Label>
            <InputTitle
              placeholder="Digite um título..."
              name="titulo_card"
              type="text"

            />
          </InputArea>
        </Div>


        <Div>
          <TextAreaContainer>
            <Label>Descrição:</Label>
            <textarea id="descricao_card" name="msg" placeholder="Digite uma descrição..."></textarea>
          </TextAreaContainer>
        </Div>







        <Div>
          <Button title="Salvar" type="submit" >
            Criar Cartão
          </Button>
        </Div>
      </FormContainer>
      <style jsx global>{`
      .swal2-container.custom-swal-container {
        z-index: 9999; 
      }
    `}</style>
    </div>

  );
};

export default Form;


